function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M76,30.3c-1.8,0-3.6-0.7-5-2.1c-2.7-2.7-2.7-7.2,0-10s7.2-2.7,10,0c2.7,2.7,2.7,7.2,0,10C79.6,29.6,77.8,30.3,76,30.3z  M76,19.3c-1,0-2,0.4-2.8,1.2c-1.5,1.5-1.5,4.1,0,5.6c1.5,1.5,4.1,1.5,5.6,0c1.5-1.5,1.5-4.1,0-5.6C78,19.6,77,19.3,76,19.3z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M76,37.9c-3.8,0-7.5-1.4-10.4-4.3c-2.8-2.8-4.3-6.5-4.3-10.4c0-3.9,1.5-7.6,4.3-10.4l0,0l0,0C68.4,10,72.1,8.5,76,8.5 c3.9,0,7.6,1.5,10.4,4.3c5.7,5.7,5.7,15.1,0,20.8C83.5,36.5,79.8,37.9,76,37.9z M76,11.6c-3.1,0-6,1.2-8.2,3.4l0,0 c-2.2,2.2-3.4,5.1-3.4,8.2s1.2,6,3.4,8.2c4.5,4.5,11.9,4.5,16.5,0c4.5-4.5,4.5-11.9,0-16.5C82,12.8,79.1,11.6,76,11.6z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M76,45.7c-6,0-11.6-2.3-15.9-6.6c-8.7-8.7-8.7-23,0-31.7c8.7-8.7,23-8.7,31.7,0c4.2,4.2,6.6,9.9,6.6,15.9 c0,6-2.3,11.6-6.6,15.9C87.6,43.3,82,45.7,76,45.7z M76,3.9c-5,0-9.9,1.9-13.7,5.7c-7.5,7.5-7.5,19.8,0,27.4 c3.7,3.7,8.5,5.7,13.7,5.7c5.2,0,10-2,13.7-5.7c3.7-3.7,5.7-8.5,5.7-13.7c0-5.2-2-10-5.7-13.7C85.9,5.8,81,3.9,76,3.9z"
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 45.6,
  y: 22.6,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 37.4175 -23.557)",
  width: 3.1,
  height: 21.6
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 46.3,
  y: 2.9,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 29.4634 -27.3874)",
  width: 3.1,
  height: 38
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 75.8,
  y: 32.4,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 59.0131 -39.6273)",
  width: 3.1,
  height: 38
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 64.9,
  y: 41.5,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 56.407 -31.6544)",
  width: 3.1,
  height: 21.6
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 24.4,
  y: 39.9,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 39.1807 -11.615)",
  width: 18.4,
  height: 3.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 20.1,
  y: 44.3,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 40.9772 -7.278)",
  width: 18.4,
  height: 3.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 15.7,
  y: 48.6,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 42.7753 -2.9405)",
  width: 18.4,
  height: 3.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 11.4,
  y: 53,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 44.5717 1.3966)",
  width: 18.4,
  height: 3.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 7.1,
  y: 57.3,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 46.3681 5.7338)",
  width: 18.4,
  height: 3.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 2.7,
  y: 61.6,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 48.1646 10.071)",
  width: 18.4,
  height: 3.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: -1.6,
  y: 66,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 49.961 14.4082)",
  width: 18.4,
  height: 3.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 24.4,
  y: 39.9,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 39.1807 -11.615)",
  width: 18.4,
  height: 3.1
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 48.7,
  y: 64.3,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 63.4911 -21.6847)",
  width: 18.4,
  height: 3.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 44.4,
  y: 68.6,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 65.2876 -17.3477)",
  width: 18.4,
  height: 3.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 40.1,
  y: 72.9,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 67.084 -13.0108)",
  width: 18.4,
  height: 3.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 35.7,
  y: 77.3,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 68.8804 -8.6738)",
  width: 18.4,
  height: 3.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 31.4,
  y: 81.6,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 70.6768 -4.3369)",
  width: 18.4,
  height: 3.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 27,
  y: 85.9,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 72.4733 7.687758e-05)",
  width: 18.4,
  height: 3.1
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 22.7,
  y: 90.3,
  transform: "matrix(0.7071 0.7071 -0.7071 0.7071 74.2697 4.337)",
  width: 18.4,
  height: 3.1
}))))));

var SvgWorkout = function SvgWorkout(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/workout.78bddfaf.svg";
export { SvgWorkout as ReactComponent };